import {
  EDIT_PROFILE,
  PROFILE_SUCCESS,
  PROFILE_ERROR,
  EDIT_MODE,
  EDIT_MODE_SUCCESS,
  EDIT_MODE_ERROR,
  EDIT_PHOTO,
  EDIT_PHOTO_SUCCESS,
  EDIT_PHOTO_FAIL,
  EDIT_IMPORTANT_ORDER,
  EDIT_PASSWORD,
  EDIT_PASSWORD_SUCCESS,
  EDIT_PASSWORD_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}
export const editImportantOrder = user => {
  return {
    type: EDIT_IMPORTANT_ORDER,
    payload: { user },
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}


export const editMode = user => {
  return {
    type: EDIT_MODE,
    payload: { user },
  }
}
export const editModeSuccess = msg => {
  return {
    type: EDIT_MODE_SUCCESS,
    payload: msg,
  }
}
export const editModeError = error => {
  return {
    type: EDIT_MODE_ERROR,
    payload: error,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const editPhoto = profile => ({
  type: EDIT_PHOTO,
  payload: profile,
})

export const editPhotoSuccess = profile => ({
  type: EDIT_PHOTO_SUCCESS,
  payload: profile,
})

export const editPhotoFail = error => ({
  type: EDIT_PHOTO_FAIL,
  payload: error,
})

export const editPassword = profile => ({
  type: EDIT_PASSWORD,
  payload: profile,
})

export const editPasswordSuccess = message => ({
  type: EDIT_PASSWORD_SUCCESS,
  payload: message,
})

export const editPasswordFail = error => ({
  type: EDIT_PASSWORD_FAIL,
  payload: error,
})

export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})

export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})
